import { Component, HostListener, Inject, AfterViewInit, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { PagerService, QuotationService, ConsultSearchOption, CnsltnReqPageModel, CnsltnReqModel, LoadingService } from '../../../../services/index';
import { RequestOptionsArgs, Headers } from '@angular/http';
import { ConsultingList } from '../../../../models/index';
import { CodeMapper } from '../../../../utils/index';
import { Subscription } from 'rxjs';
import _ from 'lodash';
import { Util } from '../../../../utils/index';
import { Route } from '@angular/compiler/src/core';
import { ActivatedRoute } from '@angular/router';
declare var moment: any;




@Component({
  selector: 'cnsltn-list-fwdr',
  templateUrl: 'cnsltn-list-fwdr.html'
})
export class CnsltnListFwdr implements OnDestroy {

  codeMapper = CodeMapper.cnsltn;

  searchOption: ConsultSearchOption;

  consultListSubscription: Subscription;
  consultPageList: CnsltnReqPageModel;
  cnsltnReqList: Array<CnsltnReqModel> = [];

  navIsFixed: boolean = false;

  filterReqTp: number;
  filterTransTp: number;
  sortType: string;
  filterType: number;

  tabIndex: number = 99;

  conditionTypeList: Array<any>;

  conditionText: string;
  isImpossible: number = 0;
  delYn: number = 0;
  imexTp: number = 99;
  startDt: string = moment(new Date()).add(-2, 'M').format('YYYYMMDD');
  endDt: string = moment(new Date()).format('YYYYMMDD');
  isSearching: boolean = false;

  constructor(
    private pagerService: PagerService,
    private quotationService: QuotationService,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document) {

    //자세히 보기에서 돌아왓을 때 검색 상태를 유지하기 위한 처리
    this.comebackSetting();
    this.selectTab(this.quotationService.curCnsltnTab);
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params != null && !_.isEmpty(params)) {
        let needSearch: boolean = false;

        if (params.userId) {
          this.conditionText = "userId:" + params.userId;
          needSearch = true;
        }

        if (params.startDt) {
          this.startDt = params.startDt;
          needSearch = true;
        }
        
        if (needSearch) {
          this.setConditions();
          this.searchConsultList();
        }
        
      };
    });
  }

  comebackSetting() {
    this.searchOption = this.quotationService.searchOption;
    this.conditionText = this.searchOption.conditionText;
    this.isImpossible = this.searchOption.isImpossible;
    this.delYn = this.searchOption.delYn;
    this.startDt = this.searchOption.startDt;
    this.endDt = this.searchOption.endDt;
    this.imexTp = this.searchOption.imexTp;

    this.filterType = this.quotationService.filterType;
    this.setFilterType(this.filterType);
    this.sortType = this.quotationService.sortType;
  }

  parseToDate(dateStr: string) {
    return moment(dateStr, 'YYYYMMDD').toDate();
  }

  setStartDt($event) {
    this.startDt = moment($event).format('YYYYMMDD');
  }

  setEndDt($event) {
    this.endDt = moment($event).format('YYYYMMDD');
  }


  selectTab(statusCd: number) {
    this.quotationService.curCnsltnTab = statusCd;
    this.searchOption.stusCd = statusCd;
    this.tabIndex = statusCd;
    this.setConditions();
    this.searchConsultList();
  }

  searchNewConsultList() {
    this.setConditions();
    this.searchConsultList();
  }

  setConditions() {
    this.searchOption.conditionText = this.conditionText;
    this.searchOption.startDt = this.startDt;
    this.searchOption.endDt = this.endDt;
    this.searchOption.isImpossible = this.isImpossible;
    this.searchOption.delYn = this.delYn;
    this.searchOption.imexTp = this.imexTp;
    this.searchOption.page = 0;
    this.cnsltnReqList = new Array();

    this.quotationService.searchOption = this.searchOption;
  }

  searchConsultList() {


    if (this.consultListSubscription) {
      this.consultListSubscription.unsubscribe();
      this.isSearching = false;
    }
    if (this.isSearching) return;
    this.isSearching = true;

    this.consultListSubscription = this.quotationService.getConsultList(this.searchOption)
      .subscribe(resp => {
        this.loadingService.isClose = true;
        this.consultPageList = resp.data;
        this.cnsltnReqList = this.cnsltnReqList.concat(this.consultPageList.dataLst);
        this.navIsFixed = false;
        this.isSearching = false;
      });
  }

  ngOnDestroy() {
    if (this.consultListSubscription) this.consultListSubscription.unsubscribe();
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {

    let scrollTop = this.document.documentElement ? this.document.documentElement.scrollTop : this.document.body.scrollTop;
    let height = this.document.body.clientHeight;
    if (!this.navIsFixed && height <= scrollTop + 1500) {
      if (this.consultPageList && this.consultPageList.totalPages && this.consultPageList.totalPages > this.consultPageList.pageNo + 1) {
        this.searchOption.page = this.consultPageList.pageNo + 1;
        this.searchConsultList();
        this.navIsFixed = true;
      }
    }
  }

  setSortType(sortType: string) {
    this.sortType = sortType;
    this.quotationService.sortType = sortType;
  }


  setFilterType(filterType: number) {
    if (filterType == 0) {
      this.filterReqTp = null;
      this.filterTransTp = null;
    } else if (filterType == 1) {
      this.filterReqTp = 0;
      this.filterTransTp = 0;
    } else if (filterType == 2) {
      this.filterReqTp = 1;
      this.filterTransTp = 0;
    } else if (filterType == 3) {
      this.filterReqTp = 1;
      this.filterTransTp = 1;
    }
    this.filterType = filterType;
    this.quotationService.filterType = filterType;
  }

  handleKeyDown(event) {
    if (event.keyCode == 13) this.searchNewConsultList();
  }

  // selectConditionType(event){
  //   this.conditionType = event;
  // }

  selectIsImpossible(event) {
    this.isImpossible = event;

    this.searchNewConsultList();
  }

  selectDelYn(event) {
    this.delYn = event;
  }

  selectImexTp(event) {
    this.imexTp = event;
  }


}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/cnsltn-list/cnsltn-list-fwdr.ts